
import React from 'react';
import PropTypes from 'prop-types';

import constants from '../../../../qti/Constants';
import globalsService from '../../../../services/GlobalsService';
import styles from './tiiFbsInteraction.scss';
import sessionReader from '../../../../store/readHelpers/SessionReader';


const previewContext = constants.componentContexts.PREVIEW;
const examContext = constants.componentContexts.EXAM;


class TiiFbsInteraction extends React.Component {
    static propTypes = {
        context: PropTypes.string.isRequired,
        handleInteractionReady: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.handleInteractionReady(true);
    }

    getPreviewUrl() {
        const assetRoot = globalsService.getAssetRoot();
        let src = 'images/tiiFbsUpload/fbs_upload_candidate_preview.png';
        if (assetRoot) {
            src = `${assetRoot}/${src}`;
        }
        return src;
    }

    renderPreview() {
        const src = this.getPreviewUrl();
        return (<div className={styles.previewWrapper}>
            <img src={src} alt="student_preview" />
        </div>);
    }

    getLtiUrl() {
        const assessmentRunId = sessionReader.getAssessmentRunId();
        return `/lticonsumer/init/${assessmentRunId}`;
    }

    renderExamIframe() {
        const src = this.getLtiUrl();
        return (<div className={styles.fbsModalContainer}>
            <iframe src={src} className={styles.fbsModal} title="FbsUploadModal" />
        </div>);
    }


    render() {
        const { context } = this.props;
        if (context === previewContext) {
            return this.renderPreview();
        } else if (context === examContext) {
            return this.renderExamIframe();
        }
        return null;
    }
}

export default TiiFbsInteraction;
